export class ActionListSummary {
    public TotalActions: number = 0;
    public OverdueActions: number = 0;
    public DueActions: number = 0;
    public NotDueActions: number = 0;
    public ResolvedActions: number = 0;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
